module.exports = __webpack_public_path__ + "static/media/white-line-circle-icon.0d20bfd4.svg";